import { ErrorHandlingHelper } from '@/_helpers';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandlingHelper = inject(ErrorHandlingHelper);

  return next(req).pipe(catchError((error: HttpErrorResponse) => errorHandlingHelper.handleApiError(error)));
};
